<template>
  <div id="app">
    <app-header></app-header>
    <default-content v-if="changContentPage(this.$route.path)"></default-content>
    <app-side-bar-content v-else></app-side-bar-content>
    
    <app-footer></app-footer>
  </div>
</template>

<script>

import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import AppSideBarContent from '@/components/AppSideBarContent'
import DefaultContent from '@/components/DefaultContent'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    AppSideBarContent,
    DefaultContent
  },
  methods:{
    changContentPage : function(obj){            
      var bundel = require('./router/routerSetting')
      return bundel.isFullScreen(obj,this.$router.options.routes);
    }      
  },
  watch: {    
    '$route' (to, from, next) {
      var bundel = require('./router/routerSetting')
      if( bundel.getLanguage() == 'en' ){
        document.title = 'Yulon Finance Corporation｜' + to.name || 'Yulon Finance Corporation'
        next();
      }else {
        document.title = '裕融企業股份有限公司｜' + to.name || '裕融企業股份有限公司'
      }        
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue